// Daily AI briefing card, fallback branch (docs/auth-and-admin/super-admin-s13-practitioner-contract.md
// section 2). When the AI cannot write the briefing the card says so, and lists the key
// numbers as label/value pairs so no sentence depends on a plural form.
export default {
  fr: {
    "insights.unavailable.notConfigured": "Briefing IA indisponible — l'IA n'est pas configurée sur cette plateforme. Voici vos chiffres clés.",
    "insights.unavailable.error": "Briefing IA indisponible pour le moment. Voici vos chiffres clés ; réessayez avec Rafraîchir plus tard.",
    "insights.fallback.bookings7d": "Rendez-vous (7 derniers jours)",
    "insights.fallback.newContacts7d": "Nouveaux contacts (7 derniers jours)",
    "insights.fallback.leads": "Leads à relancer",
  },
  en: {
    "insights.unavailable.notConfigured": "AI briefing unavailable — AI is not set up for this platform. Here are your key numbers.",
    "insights.unavailable.error": "AI briefing unavailable right now. Here are your key numbers; try Refresh later.",
    "insights.fallback.bookings7d": "Bookings (last 7 days)",
    "insights.fallback.newContacts7d": "New contacts (last 7 days)",
    "insights.fallback.leads": "Leads to follow up",
  },
  es: {
    "insights.unavailable.notConfigured": "Briefing IA no disponible — la IA no está configurada en esta plataforma. Aquí tienes tus cifras clave.",
    "insights.unavailable.error": "Briefing IA no disponible por ahora. Aquí tienes tus cifras clave; vuelve a intentarlo con Actualizar más tarde.",
    "insights.fallback.bookings7d": "Citas (últimos 7 días)",
    "insights.fallback.newContacts7d": "Contactos nuevos (últimos 7 días)",
    "insights.fallback.leads": "Leads por seguir",
  },
};
